import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { CanvasPicker, CANVASES } from './editor/CanvasPicker'
import { LivingLinkAddon } from './editor/LivingLinkAddon'
import './editor/editor.css'

export function Editor ({ ims }) {
  const [selectedCanvas, setSelectedCanvas] = useState(CANVASES[0])

  const handleCanvasSelect = useCallback((canvas) => {
    setSelectedCanvas(canvas)
  }, [])

  return (
    <div className='editor-root'>
      <CanvasPicker
        selectedId={selectedCanvas.id}
        onSelect={handleCanvasSelect}
      />
      <LivingLinkAddon canvas={selectedCanvas} ims={ims} />
    </div>
  )
}

Editor.propTypes = {
  ims: PropTypes.object
}

Editor.defaultProps = {
  ims: null
}
